// Make app globally available
window.app = window.app || {};

// Core components first
import './store.js';
import './data-manager.js';

// Utils
import './text-measurement.js';
//import './text-measurement-debug.js';
import './utils.js';

// Feature components
import './text-input.js';
import './color-selection.js';
import './layer-color-selection.js';
import './font-selection.js';
import './justification-selection.js';
import './mirrored-toggle.js';
import './bold-toggle.js';
import './italic-toggle.js';
import './discount-slider.js';
import './cart-integration.js';
import './size-input.js';
import './set-toggle.js';
import './attribute-selection.js';
import './canvas-renderer.js';
import './variable-product.js';
import './flag-position-toggle.js';

// Main initialization
import './main.js';